import { Component } from "@angular/core";
import { CommonSvgIconComponent } from "../common-svg-icon/common-svg-icon.component";

@Component({
    selector: "app-footer",
    imports: [],
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"]
})

export class FooterComponent {


}
